
function TipoVisualizacaoDados() {
  const buttons = document.querySelectorAll('[data-view-type]');

  if (buttons.length) {
    addEventListener(buttons);
  }
}

function addEventListener(buttons) {
  buttons.forEach((currentButton) => {
    currentButton.addEventListener('click', handlerCkickButton);
  });
}

function handlerCkickButton(event) {
  const button = event.target;
  const viewProps = button.dataset;
  const viewType = viewProps.viewType;
  const dataView = document.getElementById(viewProps.viewId);

  removeActiveButtons();
  button.classList.toggle('active');
  dataView.setAttribute('data-view', viewType);
}

function removeActiveButtons() {
  const buttons = document.querySelectorAll('[data-view-type]');
  buttons.forEach((currentButton) => {
    currentButton.classList.remove('active');
  });
}

module.exports = {
  init: TipoVisualizacaoDados,
  removeActiveButtons: removeActiveButtons
}
